// library imports
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// User Component imports
import * as Constants from "_core/configs/Constants";
import { setLoading, setMenuState, setErrorModal, setInitializeState } from "_core/slices/scene/SceneSlice";
import UsersLoginApi from "apis/UsersLoginApi";
import {Stack, Button, Row, Card, TextInput, Video} from "_core/components/common/UI";
import { deviceType, useDevice } from '_core/managers/ResponsiveManager';
import * as LocalStorageUtils from "_core/utils/localstorage";
import { adminLandingPage } from "_core/utils/common";

// styles imports
import './AccountTop.scss';

const top_visual = Constants.REACT_APP_BASE_PATH + '/img/admin_top_visual.png';
const logo = Constants.REACT_APP_BASE_PATH + '/img/PRizmo_rogo_big_2.png';

const AccountTop = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const ExecUsersLoginApi = UsersLoginApi();
    const [autoCompleted, setAutoCompleted] = useState(false);

    const { initializeState } = useSelector((store) => store.scene);
    const [email, setEMail] = useState('');
    const [password, setPassword] = useState('');
    const device = useDevice();

    const [emailInputValid, setEmailInputValid] = useState(true);
    const [passwordInputValid, setPasswordInputValid] = useState(true);


    useEffect(() => {
        // パスワードマネージャーによる反映を待ってから確認する
        const timerId = setTimeout(() => {
            checkAutoCompleted();
        }, 300);

        return () => {
            clearTimeout(timerId);
        }
    }, []);

    useEffect(() => {
        dispatch(setMenuState({ isHeader: false, isMenu: false, isFooter: false , isFullScreen: true  }));
    }, [dispatch]);

    useEffect(() => {
        if(initializeState === Constants.INITIALIZE_STATE.allComplete)
        {
            dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetchComplete))
        }
    }, [initializeState]);

    useEffect(() => {
        if (!autoCompleted) {
            return;
        }

        if (email !== "" || password !== "") {
            setAutoCompleted(false);
        }
    }, [email, password]);

    // 自動入力チェック
    const checkAutoCompleted = () => {
        const inputEmailEl = document.getElementById("input-email");
        const inputPasswordEl = document.getElementById("input-password");
        if (inputEmailEl && inputEmailEl.matches(':-webkit-autofill') && inputPasswordEl && inputPasswordEl.matches(':-webkit-autofill')) {
            setAutoCompleted(true);
        }
    }

    const UsersLoginApiRequest = async () => {
        LocalStorageUtils.SetItem(Constants.LOCALSTORAGE_KEYS.serviceType, "")
        // 通信中の表示を出す
        dispatch(setLoading(true));

        const result = await ExecUsersLoginApi({ email: email, password: password });
        // 通信中の表示を消す
        dispatch(setLoading(false));
        if (result.error || (result.response && result.response.error_code > 0)) {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }
        else 
        {
            navigate(adminLandingPage(result.response.t_account?.auth, result.response.t_user));
        }
    };

    const GetEnableLogin = () => {
        if (email && password && emailInputValid && passwordInputValid) {
            return true;
        } else {
            return false;
        }
    }

    const onClickLoginButton = async () => {
        if (!GetEnableLogin()) {
            console.warn("メールアドレスもしくはパスワードが入力されていません。");
            setAutoCompleted(false);
            return;
        }
        await UsersLoginApiRequest();
    }

    return (
        <div id="AccountTop">
            <Row className="width-full height-full">
                <Stack className="divide-half-area input-area height-full flex-center align-center">
                    <Stack className="height-full flex-both align-center width-320px">
                        <Stack>
                        </Stack>
                        <Stack className="spacing-16px align-center">
                            {/* 上部 */}
                            <div className="block-center">
                                <img src={logo} alt="" className="logo"/>
                            </div>
                            <h4 className="block-center">ログイン</h4>
                            <Stack className= "width-full spacing-8px margin-bottom-16px">
                                <div>メールアドレス</div>
                                <TextInput
                                    className="width-320px"
                                    type="email"
                                    default={email}
                                    onchange={(e) => setEMail(e.target.value)}
                                    placeholder="メールアドレス"
                                    name="input-email"
                                    titleEnabled={false}
                                    autocomplete="email"
                                    autocorrect={false}
                                    rules={[
                                        { type: "required"},
                                        { type: "maxLength", value: 255},
                                        { type: "custom", validate: ((v) => {return v.includes('@')}), message: "メールアドレスを入力してください"},
                                    ]}
                                    onValidate={(valid) => {setEmailInputValid(valid)}}
                                />
                            </Stack>
                            <Stack className= "width-full spacing-8px margin-bottom-16px">
                                <div>パスワード</div>
                                <TextInput
                                    className="width-320px"
                                    type="password"
                                    default={password}
                                    onchange={(e) => setPassword(e.target.value)}
                                    placeholder="パスワード"
                                    name="input-password"
                                    titleEnabled={false}
                                    autocomplete="current-password"
                                    autocorrect={false}
                                    rules={[
                                        { type: "required"},
                                        { type: "minLength", value: 8},
                                        { type: "maxLength", value: 128},
                                    ]}
                                    onValidate={(valid) => {setPasswordInputValid(valid)}}
                                />
                            </Stack>
                            <Button className={"primary width-320px " + ((autoCompleted || GetEnableLogin()) ? "" : "disabled")} onClick={onClickLoginButton}>ログイン</Button>
                        </Stack>
                        <Stack className="width-full spacing-16px align-center">
                            <hr />
                            <div className="info-text">©EVOLVE, Inc. All Rights Reserved.</div>
                        </Stack>
                    </Stack>
                </Stack>
                {! (device === deviceType.mobile.type ) && 
                    <Row className="divide-half-area info-area height-full flex-right">
                        <Stack className="top-visual-area flex-center align-center width-full">
                            <img src={top_visual} alt="" className="top-visual" />
                        </Stack>
                    </Row>
                }
            </Row>
        </div>
    );
};

export default AccountTop